var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "masterUnsubscribeModal",
    attrs: {
      id: "master-unsubscribe-confirmation-modal",
      "loaders-disabled": "",
      "modal-dialog-scrollable": false,
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_vm._v("\n    " + _vm._s(_vm.confirmText) + "\n  ")]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", [
              _vm._v("\n      " + _vm._s(_vm.confirmTextBody) + "\n    "),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { loading: _vm.loading },
                on: { click: _vm.handleMasterUnsubscribe },
              },
              [_vm._v("\n      " + _vm._s(_vm.subscribeText) + "\n    ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }